import { Component, OnInit, ViewChild } from '@angular/core';
import {
  GridDataResult,
  PageChangeEvent
} from '@progress/kendo-angular-grid';
import { AuditStdImport } from '../utilities/auditstd-import-model';
import { AuditStdEdit } from '../utilities/auditstd-edit-model';
import { AlertComponent, EnumAlertType } from '../../../../common/component/alert/alert.component'
import { Observable, Subject } from 'rxjs';

@Component({
  selector: 'app-qa-email-verification',
  templateUrl: './qa-email-verification.component.html',
  styleUrls: ['./qa-email-verification.component.scss']
})
export class QaEmailVerificationComponent implements OnInit {
  @ViewChild(AlertComponent, { static: true }) alerter: AlertComponent;
  ngOnInit() {
  }
  _editedAudit: AuditStdEdit = new AuditStdEdit(new AuditStdImport(), false, "");
  set editedAudit(data: AuditStdEdit) {
    this._editedAudit = data;
    this.items = this._editedAudit.property.filter(property => property.EditEmail == true);
    this.loadItems();

  };
  get editedAudit(): AuditStdEdit {
    return this._editedAudit;
  }
  public gridView: GridDataResult;
  public pageSize = 10;
  public skip = 0;
  public items: any[] = [];
  isValidEmail: boolean;

  constructor() {
    this.loadItems();
  }

  public pageChange(event: PageChangeEvent): void {
    this.skip = event.skip;
    this.loadItems();
  }

  private loadItems(): void {
    this.gridView = {
      data: this.items.slice(this.skip, this.skip + this.pageSize),
      total: this.items.length
    };
  }
  onEmailChange(dataItem: any): void {
    if (dataItem && dataItem.ContactEMail.length > 0) {
      this.isValidEmail = this.validateEmailAddress(dataItem.ContactEMail);
    }
    if (!this.isValidEmail && dataItem.ContactEMail.length) {
      this.alerter.showAlertMessage(5000, 'Please enter valid E-Mail Address', EnumAlertType.Error);
    }
  }
  validateBeforeCompleting(): boolean {
    let list = this.editedAudit.property.filter(p => (p.EditEmail && p.ContactEMail.length > 0 && !this.validateEmailAddress(p.ContactEMail)));
    let validations = [
      { test: () => (list.length > 0), message: "Please enter valid E-Mail Address" },
    ];
    var errors = validations.filter((validation) => validation.test())
      .map(validation => validation.message);

    if (errors.length > 0) {
      this.confirmDlg("One or more items need attention.", errors.join("\r\n"), "Validation").subscribe();
      return false;
    }

    return true;
  }

  validateEmailAddress(emailAddress: string): boolean {
    var valid = true;
    let re = new RegExp('(([a-zA-Z\-0-9\.]+@)([a-zA-Z\-0-9]+\\.)([a-zA-Z]+)[;]*)+');
    let emailsList = emailAddress.split(";");
    emailsList.forEach(function (email) {
      if (email && email.length > 0 && !re.test(email) && valid) {
        valid = false
      }
    });
    return valid;
  }
  openModal: boolean = false;
  dialogTitle: string = "";
  dialogTextLine1: string = "";
  dialogTextLine2: string = '';
  cancelButton: string = null;
  onDialogDone: Subject<boolean> = null;
  okCloseButtonClick(ok: boolean) {
    if (this.onDialogDone) {
      this.openModal = false;
      this.onDialogDone.next(ok);
    }
  }
  confirmDlg(msg: string, msg2: string, title: string, cancelButton: boolean = false): Observable<boolean> {
    this.dialogTitle = title;
    this.dialogTextLine1 = msg;
    this.dialogTextLine2 = msg2;
    this.openModal = true;
    this.onDialogDone = new Subject<boolean>();

    this.cancelButton = cancelButton ? "Cancel" : null;
    return this.onDialogDone.asObservable();
  }

  getClassStr(item: string) {

    if (item.length > 0 && !this.validateEmailAddress(item)) {
      return 'addRedBorder';
    }
    else {
      return '';
    }

  }
}
